import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/shadcn/utils';

const headingVariants = cva('scroll-m-20 text-primary-700', {
  variants: {
    variant: {
      h1: 'text-4xl leading-10 font-bold md:text-5xl md:leading-12',
      h2: 'text-3xl font-bold leading-10 md:text-4xl md:leading-12',
      h3: 'text-2xl font-semibold leading-8',
    },
  },
  defaultVariants: {
    variant: 'h3',
  },
});

const Heading = ({
  className,
  variant,
  ...props
}: React.ComponentProps<'h3'> & VariantProps<typeof headingVariants>) => {
  const Comp = variant ?? 'h3';

  return (
    <Comp className={cn(headingVariants({ variant, className }))} {...props} />
  );
};

export { Heading };
